import axios from "axios";

// Create an axios instance for authenticated requests
const axiosInstance = axios.create({
    headers: { "Content-Type": "application/json" },
    withCredentials: true, // important: include cookies in requests
});

// Create a separate instance for anonymous requests (optional)
const axiosAnonInstance = axios.create({
    headers: { "Content-Type": "application/json" },
});

export function GET(url, params) {
    return axiosInstance.get(url, { params });
}

export function GETAnonymous(url, params) {
    return axiosAnonInstance.get(url, { params });
}

export function POST(url, data) {
    return axiosInstance.post(url, data);
}

export function PUT(url, data) {
    return axiosInstance.put(url, data);
}

export function DELETE(url, data) {
    return axiosInstance.delete(url, { data });
}